export default {
  Time_to_death: 12.5,
  logN: 14.163256153669659,
  N: 1415872.0000000005,
  I0: 10,
  R0: 2.5,
  D_incbation: 4.1,
  D_infectious: 8,
  D_recovery_mild: 11,
  D_recovery_severe: 13,
  D_hospital_lag: 6,
  D_death: 4.5,
  CFR: 0.059,
  InterventionTime: 100,
  OMInterventionAmt: 0.6666666666666666,
  InterventionAmt: 0.33333333333333337,
  Time: 220,
  Xmax: 110000,
  dt: 3.07,
  P_HOSP: 0.12,
  duration: 840000000000,
  interventionLines: [
    {
      time: 116,
      amount: 0.48,
      om: 0.52,
      index: 0,
      rtIndex: 2,
      canDrag: false,
      label: '5/31: Potential phased reopening',
    },
  ],
  rtLevel0: 0,
  rtLevel1: 0.28,
  rtLevel2: 0.52,
  rtLevel3: 0.6,
  rtLevel4: 0.66,
  rtOptions: [
    {
      name: 'Normal', 
      index: 0, 
      om: 0,
      amount: '2.50',
      decrease: '0.00',
    },
    {
      name: 'Prepare', 
      index: 1, 
      om: 0.28,
      amount: '1.80',
      decrease: '28.00',
    },
    {
      name: 'Reduce', 
      index: 2, 
      om: 0.52,
      amount: '1.20',
      decrease: '52.00',
    },
    {
      name: 'Restrict', 
      index: 3, 
      om: 0.6,
      amount: '1.00',
      decrease: '60.00',
    },
    {
      name: 'Lockdown', 
      index: 4, 
      om: 0.66,
      amount: '0.85',
      decrease: '66.00',
    },
  ],
  P_travel: 0,
  P_travelersinfected: 0,
  D_travel: '2020-06-18T07:16:22.091Z',
}
